/* eslint-disable react/prop-types */
import React, { useState } from "react";
import axios from "axios";
import { Row, Col, Button, Form } from "react-bootstrap";
import FadeIn from "../../common/FadeIn";

const VenueEditForm = (props) => {
  const [VenueName, setVenueName] = useState(props.venue.VenueName);
  const [VenueAddress, setVenueAddress] = useState(props.venue.VenueAddress);
  const [Note, setNote] = useState(props.venue.Note);
  const [submitClicked, setSubmitClicked] = useState(false);
  const _id = props.venueID;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      VenueName,
      VenueAddress,
      Note,
      _id,
    };

    //Set Submit Clicked
    setSubmitClicked(true);

    const venueCreateRequest = await axios.put("/api/admin/manage/venue", data, {
      withCredentials: true,
    });

    if (venueCreateRequest.status === 200) {
      props.setSuccessMessage("Venue successfully edited.");
      setSubmitClicked(false);
      props.setViewMode("view");
      return props.fetchNewData();
    } else {
      setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <Row>
      <FadeIn delay={250} duration={450}>
        <Col>
          <Form className='p-4 text-center border shadow' onSubmit={handleSubmit}>
            <Row>
              <Col md='6'>
                <Form.Group controlId='VenueNameForm'>
                  <Form.Label>Venue Name</Form.Label>
                  <Form.Control
                    type='text'
                    maxLength='256'
                    placeholder='Venue Name'
                    value={VenueName}
                    onChange={(e) => setVenueName(e.target.value)}
                    className='border'
                    required
                  />
                  <Form.Text className='text-muted'>The name of the venue.</Form.Text>
                </Form.Group>
              </Col>
              <Col md='6'>
                <Form.Group controlId='VenueNameForm'>
                  <Form.Label>Venue Address</Form.Label>
                  <Form.Control
                    type='text'
                    maxLength='256'
                    placeholder='Venue Address'
                    value={VenueAddress}
                    onChange={(e) => setVenueAddress(e.target.value)}
                    className='border'
                    required
                  />
                  <Form.Text className='text-muted'>The full address of the venue.</Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm='12'>
                <Form.Label>Venue Note</Form.Label>
                <Form.Control
                  as='textarea'
                  type='text'
                  maxLength='1000'
                  value={Note}
                  onChange={(e) => setNote(e.target.value)}
                  className='border'
                  placeholder='None'
                  required
                />
                <Form.Text className='text-muted'>
                  Up to 1,000 characters to leave a note about the venue. Best to keep it short and
                  sweet though. Examples might be parking instructions or other facilities
                  information.
                </Form.Text>
              </Col>
            </Row>
            <Col className='mt-2 mb-2'>
              <Button
                variant='primary'
                size='lg'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={submitClicked}
              >
                Edit Venue
              </Button>
            </Col>
          </Form>
        </Col>
      </FadeIn>
    </Row>
  );
};

export default VenueEditForm;
